import { computed, ref, onMounted, onUnmounted } from 'vue';

import { BROWSER } from '../models/constants';

export const useMediaQuery = () => {
  const isMobile = computed((): boolean => {
    return windowWidth.value < 768;
  });
  const isSmallScreen = computed((): boolean => {
    return windowWidth.value < 1280;
  });
  const isMq1 = computed((): boolean => {
    return windowWidth.value < 480 && windowWidth.value > 0;
  });
  const isMq2 = computed((): boolean => {
    return windowWidth.value < 768 && windowWidth.value >= 480;
  });
  const isMq3 = computed((): boolean => {
    return windowWidth.value < 1024 && windowWidth.value >= 768;
  });
  const isMq4 = computed((): boolean => {
    return windowWidth.value < 1280 && windowWidth.value >= 1024;
  });
  const isMq6 = computed((): boolean => {
    return windowWidth.value >= 1280;
  });

  const isBetween = (smallerSize: number, largerSize: number): boolean => {
    return windowWidth.value < largerSize && windowWidth.value > smallerSize;
  };

  const isSmallerThan = (size: number): boolean => {
    return windowWidth.value < size;
  };

  const isLargerThan = (size: number): boolean => {
    return windowWidth.value > size;
  };

  const windowHeight = ref(window.innerHeight);
  const windowWidth = ref(window.innerWidth);

  const heightLessThan = (heightInPx: number): boolean => {
    return windowHeight.value < heightInPx;
  };

  const handleResize = () => {
    const innerHeight = window.innerHeight;
    const innerWidth = window.innerWidth;

    // viewport in safari excludes the scroll bar dimension - workaround just for safari
    if (browserDetect() === BROWSER.SAFARI) {
      const clientHeight = document?.documentElement?.clientHeight;
      const clientWidth = document?.documentElement?.clientWidth;

      windowHeight.value = clientHeight ?? innerHeight;
      windowWidth.value = clientWidth ?? innerWidth;
      return;
    }

    // all other browsers use window dimensions with scrollbar
    windowHeight.value = innerHeight;
    windowWidth.value = innerWidth;
  };

  const browserDetect = () => {
    const userAgent = navigator.userAgent;
    let browserName;
    if (userAgent.match(/opr\//i)) {
      browserName = BROWSER.OPERA;
    } else if (userAgent.match(/edg/i)) {
      browserName = BROWSER.EDGE;
    } else if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = BROWSER.CHROME;
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = BROWSER.FIREFOX;
    } else if (userAgent.match(/safari/i)) {
      browserName = BROWSER.SAFARI;
    }
    return browserName;
  };

  onMounted(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });

  return {
    // computed
    isMobile,
    isSmallScreen,
    isMq1,
    isMq2,
    isMq3,
    isMq4,
    isMq6,
    windowWidth,
    // methods
    browserDetect,
    heightLessThan,
    isSmallerThan,
    isLargerThan,
    isBetween,
  };
};
